export default __webpack_public_path__ + "static/media/triangle-yellow-dots.42c1fc7f.svg";